<div class="container-fluid">

  <div class="row">

    <div class="col-lg-6">
      <div class="card checkout-order-summary">
        <div class="card-body">
          <div class="p-3 bg-light mb-4">
            <h5 class="font-size-14 mb-0">Ordre de location</h5>
          </div>

          <div class="table-responsive">
            <table class="table table-centered mb-0 table-nowrap">
              <thead>
                <tr>
                  <th class="border-top-0 text-center" style="width: 110px;">Articles</th>
                  <th class="border-top-0 text-center">Quantité</th>
                  <th class="border-top-0 text-center">Prix location</th>
                </tr>
              </thead>

              <tbody>
                <!-- Boucle sur les items du panier -->
                <tr *ngFor="let item of itemsDetails" class="align-middle text-center">
                  <th scope="row">
                    <img [src]="item.image" [alt]="item.nom" class="avatar-md">
                  </th>

                  <td>
                    <div class="d-flex align-items-center justify-content-center">
                      <button class="btn btn-outline-secondary rounded-circle me-2" type="button"
                        (click)="decreaseQuantity(item)">
                        <i class="mdi mdi-minus"></i>
                      </button>
                      <input type="text" id="quantity" class="form-control text-center" style="width: 60px;"
                        [value]="item.quantity" readonly>
                      <button class="btn btn-outline-secondary rounded-circle ms-2" type="button"
                        (click)="increaseQuantity(item)">
                        <i class="mdi mdi-plus"></i>
                      </button>
                    </div>

                    <!-- Accessoires dynamiques avec NgbPopover -->
                    <!-- Accessoires dynamiques avec NgbPopover -->
                    <div class="mt-3">
                      <!-- Si les accessoires sont disponibles -->
                      <button *ngIf="item.accessoires_machine?.length" class="btn btn-outline-info"
                        [ngbPopover]="accessoiresContent" popoverTitle="" [autoClose]="'outside'">
                        Afficher Accessoires
                      </button>

                      <!-- Si aucun accessoire n'est disponible -->
                      <div *ngIf="!item.accessoires_machine?.length" class="text-muted">
                        Aucun accessoire disponible
                      </div>

                      <!-- Contenu Popover -->
                      <ng-template #accessoiresContent>
                        <div class="d-flex justify-content-end">
                          <button style="" class="btn btn-sm btn-outline-danger" (click)="closePopover()">X</button>
                        </div>
                        <div *ngFor="let accessoire of item.accessoires_machine">
                          <div class="form-check">
                            <input class="form-check-input" type="checkbox" [id]="'accessory-' + accessoire.id"
                              [(ngModel)]="accessoire.selected" (change)="updateSelectedAccessories(item)">
                            <label class="form-check-label" [for]="'accessory-' + accessoire.id">
                              {{ accessoire.accessoire.nom }}
                            </label>
                          </div>
                        </div>
                      </ng-template>

                    </div>

                  </td>

                  <td class="d-flex align-items-center justify-content-center">
                    <span class="me-3">{{ item.montant }} fcfa</span>
                    <a (click)="removeItemFromCart(item.id)" href="javascript:void(0);" class="action-icon text-danger">
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>
                  </td>
                </tr>



                <!-- Bouton pour ajouter plus de machines -->
                <tr>
                  <td colspan="3">
                    <div style="cursor: pointer;" (click)="showDialog()"
                      class="bg-primary-subtle text-primary p-3 rounded" type="button">
                      <h5 class="font-size-14 text-primary mb-0 d-flex align-items-center justify-content-between">
                        <span><i class="fas fa-shipping-fast me-2"></i> Plus de machines</span>
                        <span class="d-flex align-items-center justify-content-center">
                          <i class="ri-add-box-fill" style="font-size: 25px;"></i>
                        </span>
                      </h5>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>


    <div class="col-md-6">
      <div class="card">
        <div class="card-body">

          <div class="container my-4">
            <!-- Barre de recherche -->
            <div class="d-flex justify-content-center col-12 col-md-6 mx-auto search-box">
              <i class="mdi mdi-magnify"></i>
              <input type="text" [(ngModel)]="searchQuery" placeholder="Rechercher agriculteur"
                (input)="filterCooperatives()">
              <button type="button" (click)="clearSearch()">
                <i class="mdi mdi-close"></i>
              </button>
            </div>

            <!-- Section utilisateur -->
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-md-6">
                  <div style="cursor: pointer;" *ngIf="filteredCooperatives.length > 0">
                    <div class="user-card d-flex align-items-center" *ngFor="let cooperative of filteredCooperatives"
                      (click)="selectCooperative(cooperative)">
                      <i class="mdi mdi-account-circle" style="font-size: 2rem; margin-right: 10px;"></i>
                      <h5 class="text-left">{{ cooperative.nom }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="container mt-4" *ngIf="cooperative">
              <div class="row justify-content-center">
                <div class="col-md-6">
                  <div class="selected-cooperative card p-3">
                    <h5 class="text-center">Agriculteur sélectionné :</h5>
                    <p class="text-center"><strong>Nom :</strong> {{ cooperative.nom }}</p>
                    <!-- Ajoutez d'autres champs si nécessaire -->
                    <button class="btn btn-secondary" (click)="clearSelectedCooperative()">Désélectionner</button>
                  </div>
                </div>
              </div>
            </div>


            <!-- Période de location -->
            <h5 id="upper">Période de location</h5>

            <div class="d-flex justify-content-center date-card">
              <hr>

              <div class="col-md-6 col-sm-8">
                <div>
                  <label for="date-debut" class="form-label">Date début</label>
                  <div class="col">
                    <input [(ngModel)]="dateDebut" name="date-debut" class="form-control" type="date"
                      id="example-date-input">
                  </div>
                </div>

                <div>
                  <label for="date-fin" class="form-label">Date fin</label>
                  <div class="col">
                    <input [(ngModel)]="dateFin" name="date-fin" class="form-control" type="date"
                      id="example-date-input">
                  </div>
                </div>
              </div>
            </div>

            <!-- Coût et Réservation -->
            <div class="cost-card text-center mt-4">
              <p class="mb-1">Coût de location : <span class="fw-bold">{{ calculateTotal() }} </span></p>
              <hr class="my-2" />
              <button (click)="saveMachineLocation()" class="btn btn-dark btn-block px-4 py-2 me-2">Réserver</button>
              <button (click)="payerDemande()" class="btn btn-primary btn-block px-4 py-2 ">Payer location </button>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
  <!-- end row -->

</div>

<p-dialog header="Machine ({{machineItems.length}})" [modal]="true" [(visible)]="visible"
  [style]="{ width: '100rem', height: '100rem' }" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">

  <div class="row g-0">
    <div class="col-md-3" *ngFor="let item of machineItems">
      <div style="cursor: pointer;" (click)="addItemToCart(item)" class="product-box">
        <div class="product-img">
          <div class="product-ribbon badge bg-dark">
            {{ item?.types_machine?.nom }}
          </div>
          <img class="img-fluid mx-auto d-block product-image" [src]="item.image" alt=""
            style="max-width: 100%; height: 200px; object-fit: cover;">
        </div>

        <div class="text-center">
          <h5 class="font-size-15">
            <a href="javascript: void(0);" class="text-dark">{{ item.nom }}</a>
          </h5>
          <h5 class="mt-3 mb-0">
            <span class="text-muted me-2">{{ item.montant }} fcfa/ {{item?.etats_machine?.nom}}</span>
          </h5>
          <div class="d-flex justify-content-end">
            <button (click)="addItemToCart(item)" class="btn btn-circle ms-3 d-flex justify-content-center"
              type="button" style="background-color: #578D63;">
              <i class="mdi mdi-plus"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</p-dialog>

<p-toast position="top-center" />
<p-confirmDialog />
<ngx-ui-loader></ngx-ui-loader>
